module.exports = __webpack_public_path__ + "static/media/studentLogin3.35311e76.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Instructions/studentLogin3.gif
// module id = 1249
// module chunks = 2